import { createAction, props } from '@ngrx/store';
import { ResourceUri } from '@ngxp/rest';
import { SignatureResource, SignatureValidatorResponseResource, SignaturTaskResource } from './signatur.model';
import { ChangeEntryResource } from '@schir-int-client/register-change';

const PREFIX = '[Signatur] ';

export const downloadSignaturTaskAction = createAction(PREFIX + 'Download Signatur Task');

export const downloadSignaturTaskSuccessAction = createAction(
	PREFIX + 'Download Signatur Task Success',
	props<{
		signaturTask: SignaturTaskResource;
	}>()
);

export const createSignaturTaskAction = createAction(
	PREFIX + 'Create Signatur Task',
	props<{
		changeEntryUris: ResourceUri[];
		skipCheck: boolean;
	}>()
);

export const downloadSignaturAction = createAction(
	PREFIX + 'Download Signatur',
	props<{
		changeEntry: ChangeEntryResource;
	}>()
);

export const downloadSignaturSuccessAction = createAction(
	PREFIX + 'Download Signatur Success',
	props<{
		signatur: SignatureResource;
		refUrl: string;
	}>()
);

export const openInProgressDialogAction = createAction(PREFIX + 'Open In Progress Dialog');

export const closeInProgressDialogAction = createAction(PREFIX + 'Close In Progress Dialog');

export const cancelSignaturAction = createAction(PREFIX + 'Cancel Signatur');

export const downloadSignerScriptAction = createAction(PREFIX + 'Download Signer Script');

export const acknowledgeSignaturErrorAction = createAction(PREFIX + 'Acknowledge Signatur Error');

export const loadSignaturValidatorResponseAction = createAction(PREFIX + 'Load Signatur Validator Response');

export const loadSignaturValidatorResponseSuccessAction = createAction(
	PREFIX + 'Load Signatur Validator Response Success',
	props<{
		response: SignatureValidatorResponseResource;
	}>()
);

export const loadSignaturValidatorResponseNotFoundAction = createAction(
	PREFIX + 'Load Signatur Validator Response Not Found'
);
